import axios from "axios";

const instance = axios.create({
  timeout: 10000,
  headers: {
    "Content-Type": "application/json;charset=utf-8"
  }
});

export default {
  lang(data) {
    return axios.post("wechat/lang", data);
  },
  history() {
    return axios.post("wechat/history");
  },
  access() {
    return axios.post("wechat/access");
  },
  record() {
    return axios.post("wechat/record");
  },
  region() {
    return axios.post("wechat/region");
  },
  approval(id, status, cause) {
    return axios.post("wechat/approval", {
      id: id,
      status: status,
      cause: cause
    });
  },
  num(id, num) {
    return axios.post("wechat/num", {
      id: id,
      num: num
    });
  },
  invite(data) {
    return axios.post("wechat/invite", data);
  },
  ticket(data) {
    return axios.post("wechat/ticket", data);
  },
  getRecord(data) {
    return axios.post("wechat/getRecord", data);
  },
  // 登录系统 - start
  Login(data) {
    return axios.post("Login/login", data);
  },
  // 登录系统 - end

  staff() {
    return axios.post("admin/staff");
  },

  getRegion() {
    return axios.post("admin/region");
  },
  getInvite(data) {
    return axios.post("admin/invite", data);
  },
  getArrive(data) {
    return axios.post("admin/arrive", data);
  },
  staffData() {
    return axios.post("server/sync");
  },
  menuData() {
    return axios.post("server/menu");
  },
  changePassword(data) {
    return axios.post("admin/changePassword", data);
  },

  getSystem(data) {
    return axios.post("Server/getSystem", data);
  },
  changeSystem(data) {
    return axios.post("Server/changeSystem", data);
  },
  deleteRegion(data) {
    return axios.post("admin/deleteRegion", data);
  },
  getPort() {
    return axios.post("admin/getPort");
  },
  createRegion(data) {
    return axios.post("admin/createRegion", data);
  },
  updateRegion(data) {
    return axios.post("admin/updateRegion", data);
  },
  searchInvite(data) {
    return axios.post("admin/searchInvite", data);
  },
  // ****************
  // 被访人信息管理 - start
  searchStaff(data) {
    return axios.post("Staff/searchStaff", data);
  },
  createStaff(data) {
    //单个添加被访人信息
    return axios.post("Staff/createStaff", data);
  },
  deleteStaff(data) {
    //单个删除被访人信息
    return axios.post("Staff/deleteStaff", data);
  },

  faceStaff(data) {
    //
    return axios.post("Staff/faceStaff", data);
  },

  updateStaff(data) {
    //单个删除修改被访人信息
    return axios.post("Staff/updateStaff", data);
  },
  changeLeader(data) {
    //改变被访人是否可以进行邀请客户
    return axios.post("Staff/changeLeader", data);
  },
  changeInterview(data) {
    //改变被访人是否可以进行邀请面试
    return axios.post("Staff/changeInterview", data);
  },
  changeReleaseLeader(data) {
    //改变被访人是否可以进行放行条审批
    return axios.post("Staff/changeReleaseLeader", data);
  },
  // 被访人信息管理 - end
  // ****************
  searchVisitor(data) {
    //查找访客信息
    return axios.post("Visitor/searchVisitor", data);
  },
  deleteVisitor(data) {
    //单个删除访客信息
    return axios.post("Visitor/deleteVisitor", data);
  },

  getDepartment(data) {
    // 获取部门信息
    return axios.post("Department/getDepartment", data);
  },
  createDepartment(data) {
    //添加部门信息
    return axios.post("Department/createDepartment", data);
  },
  deleteDepartment(data) {
    //删除部门信息
    return axios.post("Department/deleteDepartment", data);
  },
  updateDepartment(data) {
    //删除修改部门信息
    return axios.post("Department/updateDepartment", data);
  },
  // ****************************************************************
  // 来访事由-start
  getReasons(data) {
    // 获取来访事由
    return axios.post("Reasons/getReasons", data);
  },
  createReasons(data) {
    //添加来访事由
    return axios.post("Reasons/createReasons", data);
  },
  deleteReasons(data) {
    //删除来访事由
    return axios.post("Reasons/deleteReasons", data);
  },
  updateReasons(data) {
    //删除修改来访事由
    return axios.post("Reasons/updateReasons", data);
  },
  // 来访事由-end
  // 拜访厂区-start
  getArea3(data) {
    // 获取拜访厂区
    return axios.post("Area/getArea3", data);
  },
  getArea(data) {
    // 获取拜访厂区
    return axios.post("Area/getArea", data);
  },
  createArea(data) {
    //添加拜访厂区
    return axios.post("Area/createArea", data);
  },
  deleteArea(data) {
    //删除拜访厂区
    return axios.post("Area/deleteArea", data);
  },
  updateArea(data) {
    //删除修改拜访厂区
    return axios.post("Area/updateArea", data);
  },
  // 拜访厂区-end
  // 拜访区域-start
  getArea2(data) {
    // 获取拜访区域
    return axios.post("Area/getArea2", data);
  },
  createArea2(data) {
    //添加拜访区域
    return axios.post("Area/createArea2", data);
  },
  deleteArea2(data) {
    //删除拜访区域
    return axios.post("Area/deleteArea2", data);
  },
  updateArea2(data) {
    //删除修改拜访区域
    return axios.post("Area/updateArea2", data);
  },
  // 拜访区域-end
  // ****************
  // 访问类型 - start
  searchVisitorType(data) {
    // 获取访问类型
    return axios.post("VisitorType/search", data);
  },
  createVisitorType(data) {
    //添加访问类型
    return axios.post("VisitorType/create", data);
  },
  deleteVisitorType(data) {
    //删除访问类型
    return axios.post("VisitorType/delete", data);
  },
  updateVisitorType(data) {
    //删除修改访问类型
    return axios.post("VisitorType/update", data);
  },
  // 访问类型 - end
  // ****************
  // 物品类型 - start
  searchItemType(data) {
    // 获取物品类型
    return axios.post("Release/searchItemType", data);
  },
  createItemType(data) {
    //添加物品类型
    return axios.post("Release/createItemType", data);
  },
  deleteItemType(data) {
    //删除物品类型
    return axios.post("Release/deleteItemType", data);
  },
  updateItemType(data) {
    //删除修改物品类型
    return axios.post("Release/updateItemType", data);
  },
  // 物品类型 - end
  // ****************
  // 放行类别 - start
  searchReleaseType(data) {
    // 获取放行类别
    return axios.post("Release/searchReleaseType",data);
  },
  createReleaseType(data) {
    //添加放行类别
    return axios.post("Release/createReleaseType", data);
  },
  deleteReleaseType(data) {
    //删除放行类别
    return axios.post("Release/deleteReleaseType", data);
  },
  updateReleaseType(data) {
    //删除修改放行类别
    return axios.post("Release/updateReleaseType", data);
  },
  // 放行类别 - end
  // ****************
  // 放行原因 - start
  getReleaseReasons() {
    // 获取放行原因
    return axios.post("Release/getReleaseReasons");
  },
  createReleaseReasons(data) {
    //添加放行原因
    return axios.post("Release/createReleaseReasons", data);
  },
  deleteReleaseReasons(data) {
    //删除放行原因
    return axios.post("Release/deleteReleaseReasons", data);
  },
  updateReleaseReasons(data) {
    //删除修改放行原因
    return axios.post("Release/updateReleaseReasons", data);
  },
  // 放行原因 - end
  // ****************

  getAccount() {
    // 获取账号信息
    return axios.post("Account/getAccount");
  },
  createAccount(data) {
    //添加账号信息
    return axios.post("Account/createAccount", data);
  },
  deleteAccount(data) {
    //删除账号信息
    return axios.post("Account/deleteAccount", data);
  },
  updateAccount(data) {
    //删除修改账号信息
    return axios.post("Account/updateAccount", data);
  },
  searchRecord(data) {
    //查找访客预约记录
    return axios.post("Record/searchRecord", data);
  },
  deleteRecord(data) {
    //删除预约记录
    return axios.post("Record/deleteRecord", data);
  },

  searchStaffRecord(data) {
    //
    return axios.post("Record/searchStaffRecord", data);
  },
  deleteStaffRecord(data) {
    //
    return axios.post("Record/deleteStaffRecord", data);
  },

  searchVisitorRecord(data) {
    //
    return axios.post("Record/searchVisitorRecord", data);
  },
  deleteVisitorRecord(data) {
    //
    return axios.post("Record/deleteVisitorRecord", data);
  },

  searchReleaseRecord(data) {
    //
    return axios.post("Release/searchRecord", data);
  },
  deleteReleaseRecord(data) {
    //删除预约记录
    return axios.post("Release/deleteRecord", data);
  },

  vpersonal(data) {
    //提交访客信息
    return axios.post("wechat/vpersonal", data);
  },
  getVisitorInfo() {
    //获取访客信息
    return axios.post("wechat/getVisitorInfo");
  },
  getStaffName(data) {
    //获取被访人姓名
    return axios.post("wechat/getStaffName", data);
  },
  // getReasons(data) {//获取来访事由
  //     return axios.post('wechat/getReasons', data);
  // },
  vreserve(data) {
    //发起预约
    return axios.post("wechat/vreserve", data);
  },
  getSVecord(data) {
    //访客获取模板消息的记录
    return axios.post("wechat/getSVecord", data);
  },

  getStaffInfo() {
    //获取被访人信息
    return axios.post("wechat/getStaffInfo");
  },
  spersonal(data) {
    //被访人员绑定信息
    return axios.post("wechat/spersonal", data);
  },
  disSpersonal(data) {
    //被访人解除绑定
    return axios.post("wechat/disSpersonal", data);
  },
  getCode(data) {
    //被访人员获取短信验证码
    return axios.post("server/getCode", data);
  },
  staffRefuse(data) {
    //被访人员拒绝来访
    return axios.post("wechat/staffRefuse", data);
  },
  staffAgree(data) {
    //被访人员同意来访
    return axios.post("wechat/staffAgree", data);
  },
  leaderRefuse(data) {
    //领导拒绝来访
    return axios.post("wechat/leaderRefuse", data);
  },
  leaderAgree(data) {
    //领导同意来访
    return axios.post("wechat/leaderAgree", data);
  },
  getSRecord(data) {
    //被访人员获取模板消息的记录
    return axios.post("wechat/getSRecord", data);
  },
  getLRecord(data) {
    //部门领导获取模板消息的记录
    return axios.post("wechat/getLRecord", data);
  },
  getVRecord(data) {
    //访客获取模板消息的记录
    return axios.post("wechat/getVRecord", data);
  },
  getCRecord(data) {
    //抄送人获取模板消息的记录
    return axios.post("wechat/getCRecord", data);
  },
  getStaffRecord() {
    //获取员工的预约、邀请记录
    return axios.post("wechat/getStaffRecord");
  },
  getVisitorRecord() {
    //获取访客预约记录
    return axios.post("wechat/getVisitorRecord");
  },

  // ***************************
  getDevice() {
    // 获取设备
    return axios.post("Device/getDevice");
  },
  createDevice(data) {
    //添加设备
    return axios.post("Device/createDevice", data);
  },
  deleteDevice(data) {
    //删除设备
    return axios.post("Device/deleteDevice", data);
  },
  updateDevice(data) {
    //删除修改设备
    return axios.post("Device/updateDevice", data);
  },

  // ***************************
  getTimu() {
    // 获取题目
    return axios.post("Timu/getTimu");
  },
  createTimu(data) {
    //添加题目
    return axios.post("Timu/createTimu", data);
  },
  deleteTimu(data) {
    //删除题目
    return axios.post("Timu/deleteTimu", data);
  },
  updateTimu(data) {
    //修改题目
    return axios.post("Timu/updateTimu", data);
  },

  get_corp_usr() {
    //
    return axios.post("Staff/getCorpUser");
  },

  // 工作流程 - start
  getWorkflow(data) {
    // 获取工作流程
    return axios.post("Workflow/get", data);
  },
  createWorkflow(data) {
    //添加工作流程
    return axios.post("Workflow/create", data);
  },
  deleteWorkflow(data) {
    //删除工作流程
    return axios.post("Workflow/delete", data);
  },
  updateWorkflow(data) {
    //删除修改工作流程
    return axios.post("Workflow/update", data);
  },

  getWorkflowList(data) {
    // 获取工作流程
    return axios.post("WorkflowList/get", data);
  },
  createWorkflowList(data) {
    //添加工作流程
    return axios.post("WorkflowList/create", data);
  },
  deleteWorkflowList(data) {
    //删除工作流程
    return axios.post("WorkflowList/delete", data);
  },
  updateWorkflowList(data) {
    //删除修改工作流程
    return axios.post("WorkflowList/update", data);
  },
  // 工作流程 - end

  /**
   * 主图操作，获取、添加和删除
   **/
  getMainPhoto(data) {
    // 获取主图信息
    return axios.post("MainPhoto/getMainPhoto", data);
  },
  createMainPhoto(data) {
    //添加主图信息
    return axios.post("MainPhoto/createMainPhoto", data);
  },
  deleteMainPhoto(data) {
    //删除主图信息
    return axios.post("MainPhoto/deleteMainPhoto", data);
  },

  /**
   * 现场登记
   */
  searchRecordRegister(data) {
    return axios.post("Record/searchRecordRegister", data);
  },
  deleteRecordRegister(data) {
    return axios.post("Record/deleteRecordRegister", data);
  },

  checkOutRecordRegister(data) {
    return axios.post("Record/checkOut", data);
  },

  /**
   * 二维码通行
   */
  searchRecordPass(data) {
    return axios.post("Record/searchRecordPass", data);
  },
  deleteRecordPass(data) {
    return axios.post("Record/deleteRecordPass", data);
  },

  /**
   * 无效通行数据
   */
  searchRecordErrPass(data) {
    return axios.post("Record/searchRecordErrPass", data);
  },
  deleteRecordErrPass(data) {
    return axios.post("Record/deleteRecordErrPass", data);
  },

  /**
   * 公司管理
   */
  getCompany(data) {
    // 获取公司信息
    return axios.post("Company/get", data);
  },
  createCompany(data) {
    //添加公司信息
    return axios.post("Company/create", data);
  },
  deleteCompany(data) {
    //删除公司信息
    return axios.post("Company/delete", data);
  },
  updateCompany(data) {
    //删除修改公司信息
    return axios.post("Company/update", data);
  },
  /**
   * 应用管理
   */
  getCorp(data) {
    // 获取
    return axios.post("Corp/get", data);
  },
  createCorp(data) {
    //添加
    return axios.post("Corp/create", data);
  },
  deleteCorp(data) {
    //删除
    return axios.post("Corp/delete", data);
  },
  updateCorp(data) {
    //修改
    return axios.post("Corp/update", data);
  },
  /**
   * 组织管理
   */
  getOrganize(data) {
    // 获取
    return axios.post("Organize/get", data);
  },
  createOrganize(data) {
    //添加
    return axios.post("Organize/create", data);
  },
  deleteOrganize(data) {
    //删除
    return axios.post("Organize/delete", data);
  },
  updateOrganize(data) {
    //修改
    return axios.post("Organize/update", data);
  }
};



// WEBPACK FOOTER //
// ./src/http.js